import { useState, ChangeEvent, useCallback } from 'react';

import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Textarea } from 'UIPackage/MainModule/components/Textarea';

import styles from './ChangeStatusModal.module.scss';

interface IChangeStatusModalProps {
  visible?: boolean;
  onApply: (commentText?: string) => void;
  onClose: () => void;
}

export const ChangeStatusModal = ({ visible, onApply, onClose }: IChangeStatusModalProps) => {
  const [commentTextareaValue, setCommentTextareaValue] = useState('');

  const handleCommentTextareaChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setCommentTextareaValue(e.target.value);
  }, []);

  const handleSendButtonClick = useCallback(() => {
    onApply(commentTextareaValue);
    setCommentTextareaValue('');
  }, [commentTextareaValue, onApply]);

  const handleAfterClose = useCallback(() => setCommentTextareaValue(''), []);

  return (
    <Modal visible={visible} modalBodyClassName={styles.ModalBody} onClose={onClose} afterClose={handleAfterClose}>
      <ModalHeader title="Комментарий" />
      <ModalBody>
        <h4 className={styles.Subtitle}>Комментарий представителя органа прокуратуры/органа контроля</h4>
        <Textarea
          className={styles.CommentTextarea}
          inputClassName={styles.CommentTextareaInput}
          value={commentTextareaValue}
          resize="vertical"
          autoHeight={false}
          onChange={handleCommentTextareaChange}
        />
      </ModalBody>
      <ModalActions>
        <Button
          text="Отправить комментарий"
          color="primary"
          size="medium"
          type="button"
          onClick={handleSendButtonClick}
        />
      </ModalActions>
    </Modal>
  );
};
